import { useHistory, useLocation } from "react-router-dom";
import InitApi from "api/InitApi";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";
import toast from "react-hot-toast";

const useAddSeats = (subscriptionId, onSuccess) => {
	const { accessToken } = useTokenStore();
    const history = useHistory();
    const location = useLocation();
	const queryClient = useQueryClient();

	const addSeats = async (data) => {
		const instance = await InitApi({ accessToken });
		const res = await instance.post(`subscriptions/${subscriptionId}/add-seats`, data);

		queryClient.invalidateQueries("is_subscribed");
		queryClient.invalidateQueries("subscriptions");
		queryClient.invalidateQueries("my-profile");
		queryClient.invalidateQueries("calculate-prorated-cost");
		queryClient.invalidateQueries("books");
		return res.data;
	};

	return useMutation((data) => addSeats(data), {
		onSuccess: (data) => {
            if (data?.data?.status === "Pending") {
                const order = data.data;
                const params = new URLSearchParams({ order_id: order.id, phone: order.phone || "", reference: order.reference || "", retryUrl: location.pathname });
                history.push(`/payment-response?${params}`);
                return;
            }
			toast.success(data?.message || "Seats added successfully!");
			if (onSuccess) onSuccess(data);
		},
		onError: (error) => {
			const message =
				error?.response?.data?.message ||
				error?.message ||
				"Failed to add seats. Please try again.";
			toast.error(message);
		},
	});
};

export default useAddSeats;
